import { ReactComponent as Bg } from "../assets/svg/flags/1x1/bg.svg";





class Country {


	options = [
		{
			label:"Bulgaria",
			value:"Bulgaria",
			flag:"bg",
			icon: <Bg width={24} height={24} />,
			className: 'flag-icon',
			fetchOwners: false
		},
	];
	
	constructor() {
		

	}
	get(value){
		
		const v = Array.isArray(value) ? value : [value];
		
		var res = [];
		
		v.forEach((val)=>{
			const r = this.options.find((a)=>{return a.value == val});
			if(r)
				res.push(r);
		});
		return res.length > 1 ? res : res[0];	
	}
	
	getCode(country){

		var idx = this.options.findIndex((a)=>{
			return a.value == country;
		})

		if(idx != -1)
			return this.options[idx].flag;

		return '';
	}

	//whether landowner information can be fetched (e.g. from Land Book) for projects in this country
	canFetchOwners(country){

		var idx = this.options.findIndex((a)=>{
			return a.value == country;
		})

		if(idx != -1)
			return !!this.options[idx].fetchOwners;

		return false;
	}
	
	
}

export default new Country();